import css from "standard/css";

const style = css`
  :root {
    --shadow-level-0: none;
    --shadow-solid: 0px 5px 2px rgba(0, 0, 0, 0.1);
    --shadow-level-1: 0px 4px 12px -1px rgba(0, 0, 0, 0.1);
    --shadow-level-2: 0px 5px 14px -1px rgba(0, 0, 0, 0.12);
    --shadow-level-3: 0px 5px 14px -1px rgba(0, 0, 0, 0.12);
    --shadow-level-4: 0px 7px 18px -1px rgba(0, 0, 0, 0.16);
    --shadow-level-5: 0px 8px 20px -1px rgba(0, 0, 0, 0.18);
  }
`;

export default style;
